import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useStaticQuery, graphql } from 'gatsby';

import { getMenuLinkClasses } from '../utils/utils';
import { MenuFields } from '../graphql-fragments/MenuFieldsFragment';
import { LocationContext } from '../contexts/LocationContext';
import { HIDDEN_FEATURES } from '../constants';

import * as styles from './Menu.module.scss';

interface MenuProps {
  narrow?: boolean;
}

const Menu = ({ narrow }: MenuProps): React.ReactElement => {
  const location = useContext(LocationContext);
  const { t } = useTranslation();
  const data: MenuFields = useStaticQuery(
    graphql`
      {
        ...MenuFields
      }
    `,
  );

  const entries = [
    {
      url: '/who-we-are/ascenza',
      urlForSelectedCheck: '/who-we-are',
      title: t('menu.who_we_are', 'Who we are'),
    },

    ...(!HIDDEN_FEATURES.includes('products')
      ? [
          {
            url: '/products',
            urlForSelectedCheck: '/products',
            title: t('menu.products', 'Products'),
          },
        ]
      : []),
    ...(!HIDDEN_FEATURES.includes('distributors_page')
      ? [
          {
            url: '/distributors',
            urlForSelectedCheck: '/distributors',
            title: t('menu.distributors', 'Distributors'),
          },
        ]
      : []),
    ...(data.allSanityNewsArticle.totalCount > 0
      ? [
          {
            url: '/news',
            urlForSelectedCheck: '/news',
            title: t('menu.news', 'News'),
          },
        ]
      : []),
    ...(data?.sanityResourcesPage?.articlesAndFilesSections &&
    data.sanityResourcesPage.articlesAndFilesSections.length +
      data.allSanityResourceVideo.totalCount +
      data.allSanityResourceLink.totalCount >
      0
      ? [
          {
            url:
              '/resources/' +
              (data.sanityResourcesPage &&
              data.sanityResourcesPage.articlesAndFilesSections &&
              data.sanityResourcesPage.articlesAndFilesSections.length > 0
                ? 'articlesAndFilesSections' in data.sanityResourcesPage.articlesAndFilesSections[0]
                  ? data.sanityResourcesPage.articlesAndFilesSections[0].articlesAndFilesSections[0]
                      .slug.current
                  : data.sanityResourcesPage.articlesAndFilesSections[0].slug.current
                : data.allSanityResourceVideo.totalCount > 0
                ? 'videos'
                : 'useful-links'),
            urlForSelectedCheck: '/resources',
            title: t('menu.resources', 'Resources'),
          },
        ]
      : []),
    {
      url: '/contactUs',
      urlForSelectedCheck: '/contactUs',
      title: t('menu.contact_us', 'Contact us'),
    },
  ];

  return (
    <nav className={styles.menuDesktop + (narrow ? ' ' + styles.narrow : '')}>
      <ul className={styles.container}>
        {entries.map(({ url, urlForSelectedCheck, title }, i) => (
          <React.Fragment key={i}>
            {i > 0 && <li className={styles.linkSpacer}></li>}
            <li key={i} className={styles.linkWrapper}>
              <Link
                to={url}
                className={
                  styles.link +
                  (location
                    ? getMenuLinkClasses(
                        location.pathname,
                        urlForSelectedCheck,
                        url,
                        styles.selected,
                        styles.disabled,
                      )
                    : '')
                }
              >
                {title}
              </Link>
            </li>
          </React.Fragment>
        ))}
      </ul>
    </nav>
  );
};

export default Menu;
